/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_Remove_FailedInputs */



/**
* | output |
* | --- |
* | "Could not remove the template file." |
*
* @param {Presentation_Template_Master_Remove_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_remove_failed = /** @type {((inputs?: Presentation_Template_Master_Remove_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_Remove_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Vorlagendatei konnte nicht entfernt werden.")
	return /** @type {LocalizedString} */ ("Could not remove the template file.")
});